import { useCallback, useReducer } from 'react';
import {
  clearAndSelectItems,
  clearSelectedItems,
  massActionsInitialState,
  massActionsReducer,
  removeItem,
  removeItems,
  resetState,
  selectAllOrClearAll,
  selectItem,
  selectItems,
  syncAndToggleItems,
  toggleItem,
  toggleItems,
} from './useMassActions.state';

const useMassActions = <T>() => {
  const [state, dispatch] = useReducer(massActionsReducer<T>(), massActionsInitialState);

  const memoizedClearAndSelectItems = useCallback(
    (keys: Set<T>) => dispatch(clearAndSelectItems(keys)),
    [],
  );
  const memoizedClearSelectedItems = useCallback(() => dispatch(clearSelectedItems()), []);
  const memoizedRemoveItem = useCallback((key: T) => dispatch(removeItem(key)), []);
  const memoizedRemoveItems = useCallback((keys: Set<T>) => dispatch(removeItems(keys)), []);
  const memoizedReset = useCallback(() => dispatch(resetState()), []);
  const memoizedSelectItem = useCallback((key: T) => dispatch(selectItem(key)), []);
  const memoizedSelectItems = useCallback((keys: Set<T>) => dispatch(selectItems(keys)), []);
  const memoizedSyncAndToggleItems = useCallback(
    (keys: Set<T>) => dispatch(syncAndToggleItems(keys)),
    [],
  );
  const memoizedToggleItem = useCallback((key: T) => dispatch(toggleItem(key)), []);
  const memoizedToggleItems = useCallback((keys: Set<T>) => dispatch(toggleItems(keys)), []);
  const memoizedSelectAllOrClearAll = useCallback((keys: Set<T>) => {
    dispatch(selectAllOrClearAll(keys));
  }, []);

  return {
    selectedItems: state.selectedItems,
    clearAndSelectItems: memoizedClearAndSelectItems,
    clearSelectedItems: memoizedClearSelectedItems,
    removeItem: memoizedRemoveItem,
    removeItems: memoizedRemoveItems,
    reset: memoizedReset,
    selectItem: memoizedSelectItem,
    selectItems: memoizedSelectItems,
    syncAndToggleItems: memoizedSyncAndToggleItems,
    toggleItem: memoizedToggleItem,
    toggleItems: memoizedToggleItems,
    selectAllOrClearAll: memoizedSelectAllOrClearAll,
  };
};

export default useMassActions;
